import clsx from "clsx";
import React, { FC } from "react";
import { Link } from "@tanstack/react-router";
import { twMerge } from "tailwind-merge";

interface Props {
  children: React.ReactNode;
  link?: string;
}

const TR: FC<
  Props &
    React.DetailedHTMLProps<
      React.TableHTMLAttributes<HTMLTableRowElement>,
      HTMLTableRowElement
    >
> = ({ children, link, className, ...props }) => (
  <tr
    {...props}
    className={twMerge(
      clsx(
        !!link && "relative",
        !!props.onClick || !!link ? "cursor-pointer hover:bg-stone-50" : "",
      ),
      className,
    )}
  >
    {!!link && (
      <td className="z-1 absolute h-full w-full">
        <Link to={link} className="z-1 block h-full w-full text-transparent">
          Link
        </Link>
      </td>
    )}
    {children}
  </tr>
);

export default TR;
